<template>
    <div>
        <div class="vx-col w-full md:w-full document_tags" v-if="showOrHideField({section: value.section, key: value.key})">
            <div class="form_group">
                <div class="d-flex align-end mb-1" :key="checkProperty(value, 'key')">
                <label class="form_label">{{ checkProperty(value, 'lebel')}}<em v-if="value.required">*</em>
                    <div class="IB_tooltip" v-if="tooltip">
                    <span>
                      <info-icon size="1.5x" class="custom-class"></info-icon>
                    </span>
                    <div class="tooltip_cnt">
                      <p>
                        {{tooltip}}
                      </p>
                    </div>
                  </div>
                
                
                
                </label>
                    <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields()">
                            <span class="custom_checkbox" :class="{'checked':value.fieldRequired}" >
                                <span class="checkmark" ><i class="material-icons">check</i></span>
                            </span>
                            <div class="tooltip_cnt">
                                <p>Field is required</p>
                            </div>
                        </div>
                        <div class="check_box_list" v-if="value.fieldRequired">
                            <vs-checkbox v-model="value.required"
                            @change="updateData()"></vs-checkbox>
                            <div class="tooltip_cnt">
                                <p>Validation is required</p>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <span class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5">
                    <img src="@/assets/images/main/file-upload.svg" class="file-icon" />Upload
                    <input type="file" name="false"  id="null" 
                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" />
                </span>
                <ul class="uploaded-list">
                    <template v-if="checkProperty(tagsList, 'length')>0">
                        <template v-for="(tag, index) in tagsList">
                            <template v-if="checkProperty(tag, 'isSelected')">
                                <vs-chip @click="tag.isSelected = false;updateData()" :closable="isEdit == true">
                                    {{ tag['name'] }}
                                </vs-chip>
                            </template>
                        </template>
                    </template>
                   
                </ul>
               
               
            </div>
            <div class="slected_items" v-if="isEdit">
                <ul>
                    <li class="dropdown-list">
                        <vs-dropdown ref="tagDropdown" vs-custom-content vs-trigger-click class="cursor-pointer menu__label IB_tooltip" >
                            <span>+</span>
                            <div class="tooltip_cnt right"><p>Add to USCIS Folders</p></div>
                            <vs-dropdown-menu color="#fff" class="vx-navbar-dropdown"  >
                                <VuePerfectScrollbar
                                ref="mainSidebarPss"
                                class="scroll-area--main-sidebar"
                                :settings="settings"
                                @ps-scroll-y="scroll">
                                <ul class="document_tags_list">
                                    <template v-for="(tag, ind) in tagsList">
                                        <li > 
                                            <vs-checkbox v-model="tag.isSelected" :key="ind" @change="updateData()">
                                                {{ tag['name'] }}
                                            </vs-checkbox>
                                        </li>
                                    </template>
                                </ul>
                                </VuePerfectScrollbar> 
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import { InfoIcon } from 'vue-feather-icons'
import _ from "lodash";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
    props: {
        value: null,
        isEdit:{
            type:Boolean,
            default:false
        },
        dbFields:{
            type:Array,
            default:[]
        },
        tagsMasterList:{
            type:Array,
            default:[]
        },
        tooltip:{
            type:String,
            default:''
        },
    },
    data() {
        return{
            settings: { },
            tagsList:[],
        }
    },
    components: {
        InfoIcon,
        VuePerfectScrollbar,
    },
    methods: {
        updateData(){
            if(this.tagsList && this.checkProperty(this.tagsList, 'length')>0){
                this.value['efileDocTagIds'] = [];
                _.forEach(this.tagsList, (tagItem)=>{
                    if(tagItem && tagItem['isSelected']){
                        if(this.value['efileDocTagIds'].indexOf(tagItem['id'])<=-1){
                            this.value['efileDocTagIds'].push(tagItem['id'])
                        }
                    }
                })
            }
            this.$emit('updateFields', this.value)
        },
        showOrHideField({section= '',key= ''}){
            let localSection = section
            let localKey = key
            if(this.isEdit){
                return true
            }else if(this.checkProperty(this.dbFields, "length") > 0) {
                let dbItem = _.find(this.dbFields, {'section':localSection,'key':localKey})
                if(dbItem){
                    return true
                }
                else {
                    return false
                }
            }else{
                return true
            }
        },
        toogleFields(){
            this.value.fieldRequired?this.value.fieldRequired=false:this.value.fieldRequired =true;
            if(this.value.fieldRequired == false){
                this.value.required = false
            }
            this.updateData()
        },
        scroll(){},
    },
    mounted() {
        let self = this;
        this.tagsList = _.cloneDeep(this.tagsMasterList);
        if(self.checkProperty(self.value, 'efileDocTagIds') && self.checkProperty(self.value, 'efileDocTagIds', 'length')>0 && self.checkProperty(self.tagsList, 'length')>0){
            let ids = self.value['efileDocTagIds']
            _.forEach(self.tagsList, (tItem)=>{
                if(ids.indexOf(tItem['id'])>-1){
                    tItem['isSelected'] = true;
                }
            })
        }else{
            self.value =  Object.assign(self.value, { "efileDocTagIds": [] });
        }
        
        //console.log(JSON.stringify(this.value))
    },
    computed: {

    }
}

</script>